import { lazy } from "react";
import MainContent from "../Components/MainContent/MainContent";

const AboutUs = lazy(() => import("../Components/AboutUs/AboutUs"));
const WarrantyContent = lazy(
  () => import("../Components/Warranty/WarrantyContent")
);
const TransactionCarDetail = lazy(
  () => import("../Components/TodayTransaction/Operations/TransactionCarDetail")
);
const AppErrorPayment = lazy(
  () => import("../Components/Application/ErrorPayment")
);
const IosErrorPayment = lazy(
  () => import("../Components/Application/IosErrorPayment")
);
const IosSuccessCreditPayment = lazy(
  () => import("../Components/Application/IosSuccessCreditPayment")
);
const IosSuccessPayment = lazy(
  () => import("../Components/Application/IosSuccessPayment")
);
const SuccessCreditPayment = lazy(
  () => import("../Components/Application/SuccessCreditPayment")
);
const AppSuccessPayment = lazy(
  () => import("../Components/Application/SuccessPayment")
);
const CompaireAdvertises = lazy(
  () => import("../Components/CompaireAdvertises/CompaireAdvertises")
);
const ContactUs = lazy(() => import("../Components/ContactUs/ContactUs"));
const ExpertContent = lazy(() => import("../Components/Expert/ExpertContent"));
const FaqContents = lazy(() => import("../Components/FaqContents/FaqContents"));
const Suggestion = lazy(
  () => import("../Components/Footer/Suggestion/Suggestion")
);
const ForgetPass = lazy(() => import("../Components/ForgetPass/ForgetPass"));
const Login = lazy(() => import("../Components/Login/Login"));
const ManaPrices = lazy(() => import("../Components/ManaPrices/ManaPrices"));
const ManaRules = lazy(() => import("../Components/ManaRules/ManaRules"));
const MyCars = lazy(() => import("../Components/MyCars/MyCars"));
const MyFavouriteOrders = lazy(
  () => import("../Components/MyFavouriteOrders/MyFavouriteOrders")
);
const MyProfile = lazy(() => import("../Components/MyProfile/MyProfile"));
const MyPurchaseOrders = lazy(
  () => import("../Components/MyPurchaseOrders/MyPurchaseOrders")
);
const MyReservations = lazy(
  () => import("../Components/MyReservations/MyReservations")
);
const MySalesOrders = lazy(
  () => import("../Components/MySalesOrders/MySalesOrders")
);
const NewCar = lazy(() => import("../Components/NewCar/NewCar"));
const ErrorPayment = lazy(
  () => import("../Components/PayResults/ErrorPayment")
);
const SuccessPayment = lazy(
  () => import("../Components/PayResults/SuccessPayment")
);
const SuccessRaise = lazy(
  () => import("../Components/PayResults/SuccessRaise")
);
const PriceEstimation = lazy(
  () => import("../Components/PriceEstimation/PriceEstimationForm")
);
const Privacy = lazy(() => import("../Components/Privacy/Privacy"));
const PurchaseContent = lazy(
  () => import("../Components/PurchaseContent/PurchaseContent")
);
const OfferPrice = lazy(
  () => import("../Components/PurchaseOrder/OfferPrice/OfferPrice")
);
const PurchaseCarDetail = lazy(
  () =>
    import("../Components/PurchaseOrder/PurchaseCarDetail/PurchaseCarDetail")
);
const PurchaseCarResevation = lazy(
  () =>
    import(
      "../Components/PurchaseOrder/PurchaseCarReservation/PurchaseCarReservation"
    )
);
const PurchaseOrderForm = lazy(
  () =>
    import("../Components/PurchaseOrder/PurchaseOrderForm/PurchaseOrderForm")
);
const RaiseCredit = lazy(() => import("../Components/RaiseCredit/RaiseCredit"));
const RegisterPurchaseOrder = lazy(
  () => import("../Components/RegisterPurchaseOrder/RegisterPurchaseOrder")
);
const SaleContent = lazy(() => import("../Components/SaleContent/SaleContent"));
const CarInfo = lazy(
  () => import("../Components/SalesOrder/SalesOrderForm/CarInfo/CarInfo")
);
const SalesOrderDoc = lazy(
  () => import("../Components/SalesOrder/SalesOrderForm/Document/Document")
);
const Expert = lazy(
  () => import("../Components/SalesOrder/SalesOrderForm/Expert/Expert")
);
const SalesOrderComment = lazy(
  () =>
    import("../Components/SalesOrder/SalesOrderForm/OrderComment/OrderComment")
);
const SalesOrderForm = lazy(
  () => import("../Components/SalesOrder/SalesOrderForm/SalesOrderForm")
);
const SampleFile = lazy(() => import("../Components/SampleFile/SampleFile"));
const SignUp = lazy(() => import("../Components/SignUp/SignUp"));
const AllTransactions = lazy(
  () => import("../Components/AllTransactions/AllTransactions")
);
const Units = lazy(() => import("../Components/Units/Units"));
const Information = lazy(() => import("../Components/Information/Information"));
const FacilitiesForm = lazy(
  () => import("../Components/Facilities/FacilitiesForm/FacilitiesForm")
);
const Introducing = lazy(() => import("../Components/Introducing/Introducing"));

const routes = [
  { path: "/", component: MainContent },
  // { path: "/expert-order", component: ExpertOrderForm },
  { path: "/sell", component: SalesOrderForm },
  { path: "/sell-info", component: CarInfo },
  { path: "/estimation", component: PriceEstimation },
  { path: "/purchase-order", component: PurchaseOrderForm },
  { path: "/cmp-purchase-order", component: PurchaseOrderForm },
  { path: "/my-favourites-orders", component: MyFavouriteOrders },
  { path: "/register-purchase-order", component: RegisterPurchaseOrder },
  { path: "/sign-in", component: Login },
  { path: "/sign-up", component: SignUp },
  { path: "/forget-pass", component: ForgetPass },
  { path: "/sell-docs", component: SalesOrderDoc },
  { path: "/sell-expert", component: Expert },
  { path: "/sell-cm", component: SalesOrderComment },
  { path: "/purchase-car-details", component: PurchaseCarDetail },
  { path: "/transaction-car-details", component: TransactionCarDetail },
  { path: "/purchase-car-reserve", component: PurchaseCarResevation },
  { path: "/offer-price", component: OfferPrice },
  { path: "/my-profile", component: MyProfile },
  { path: "/my-reservations", component: MyReservations },
  { path: "/about-us", component: AboutUs },
  { path: "/contact-us", component: ContactUs },
  { path: "/privacy", component: Privacy },
  { path: "/my-reservations", component: MyReservations },
  { path: "/my-cars", component: MyCars },
  { path: "/my-sales-orders", component: MySalesOrders },
  { path: "/my-purchase-orders", component: MyPurchaseOrders },
  { path: "/scs-pay", component: SuccessPayment },
  { path: "/err-pay", component: ErrorPayment },
  { path: "/scs-rs-crt", component: SuccessRaise },
  { path: "/err-rs-crt", component: ErrorPayment },
  { path: "/app-pay-success", component: AppSuccessPayment },
  { path: "/app-credit-success", component: SuccessCreditPayment },
  { path: "/app-pay-error", component: AppErrorPayment },
  { path: "/ios-pay-success", component: IosSuccessPayment },
  { path: "/ios-credit-success", component: IosSuccessCreditPayment },
  { path: "/ios-pay-error", component: IosErrorPayment },
  { path: "/new-car", component: NewCar },
  { path: "/raise-credit", component: RaiseCredit },
  { path: "/mana-prices", component: ManaPrices },
  { path: "/faq", component: FaqContents },
  { path: "/cmpr-ad", component: CompaireAdvertises },
  { path: "/prchs-cntnt", component: PurchaseContent },
  { path: "/sls-cntnt", component: SaleContent },
  { path: "/rules", component: ManaRules },
  { path: "/expert", component: ExpertContent },
  { path: "/warranty", component: WarrantyContent },
  { path: "/mana-forms", component: SampleFile },
  { path: "/sug", component: Suggestion },
  { path: "/price-estimate", component: PriceEstimation },
  { path: "/all-trns", component: AllTransactions },
  { path: "/unts", component: Units },
  { path: "/info", component: Information },
  { path: "/fac-form", component: FacilitiesForm },
  { path: "/intro-to-others", component: Introducing },
];

export default routes;
